import { render, staticRenderFns } from "./PortalHome.vue?vue&type=template&id=5f03f42f&scoped=true"
import script from "./PortalHome.vue?vue&type=script&lang=js"
export * from "./PortalHome.vue?vue&type=script&lang=js"
import style0 from "./PortalHome.vue?vue&type=style&index=0&id=5f03f42f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f03f42f",
  null
  
)

export default component.exports